export enum EStep {
  PLATFORM = 0,
  ACCOUNT = 1,
  CONNECT = 2,
  LOADING = 3,
  DONE = 4
}

enum Autoresponder {
  AWEBER = 21,
  BLING = 31,
  CONVERTKIT = 38,
  GDIGITAL = 43,
  GDIGITALNEW = 46,
  HOTZAPP = 40,
  INFUSIONSOFT = 16,
  MAILRELAY = 22,
  PIPZ = 37
}

export const AUTORESPONDERS_WITH_CREATION_DISABLED = [
  Autoresponder.AWEBER,
  Autoresponder.BLING,
  Autoresponder.CONVERTKIT,
  Autoresponder.GDIGITAL,
  Autoresponder.GDIGITALNEW,
  Autoresponder.HOTZAPP,
  Autoresponder.INFUSIONSOFT,
  Autoresponder.MAILRELAY,
  Autoresponder.PIPZ
];
